import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { resolveModuleForPath } from '../constants/appModules';

const ProtectedRoute = ({ children, allowedRoles, requiredModule }) => {
  const { isAuthenticated, hasRole, canAccessModule, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  // Staff: module-based access (dashboard always allowed as landing page)
  if (user?.role === 'staff') {
    const moduleKey = requiredModule || resolveModuleForPath(location.pathname);
    if (moduleKey && moduleKey !== 'dashboard' && !canAccessModule(moduleKey)) {
      return <Navigate to="/dashboard" replace />;
    }
    return children;
  }

  if (allowedRoles && !hasRole(allowedRoles)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
